module.exports = __webpack_public_path__ + "media/31.c112a7b5.wav";